import React from "react";

const DoubleTickIcon = ({ myStyle, alt }) => {
    if (alt) {
        return (
            <>
                <svg
                    className={`${myStyle}`}
                    viewBox="0 0 3404 1911"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M1699.2,1501.55l-625.356,-625.356l-204.296,204.296l829.893,829.894l204.297,-204.296l-0.242,-0.242l1500.35,-1500.35l-204.296,-204.296l-1500.35,1500.35Zm-1699.2,-420.855l762.263,762.263l204.296,-204.297l-762.263,-762.262l-204.296,204.296Zm2327.37,-1080.7l-852.678,852.677l204.296,204.297l852.678,-852.678l-204.296,-204.296Z" />
                </svg>
            </>
        );
    }

    return (
        <>
            <svg
                className={`${myStyle}`}
                viewBox="0 0 3404 1911"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
            >
                <path d="M1699.2,1501.55l-625.356,-625.356l-204.296,204.296l829.893,829.894l204.297,-204.296l-0.242,-0.242l1500.35,-1500.35l-204.296,-204.296l-1500.35,1500.35Zm-1699.2,-420.855l762.263,762.263l204.296,-204.297l-762.263,-762.262l-204.296,204.296Zm2327.37,-1080.7l-852.678,852.677l204.296,204.297l852.678,-852.678l-204.296,-204.296Z" />
            </svg>
        </>
    );
};

export default DoubleTickIcon;
